import React, {useState, useEffect} from 'react'
import { Input } from "antd";

const ActionTakenInput = ({
    hazardCard,
    setHazardCard,
    isRep
}) => {
    const [maxChar, setMaxChar] = useState("0");

    useEffect(() => {
        setMaxChar(hazardCard.immediateActionTakenDetails.length);
    }, [hazardCard.immediateActionTakenDetails]);
    
    return (
        <>
            <span style={{color: "red"}}>*</span> Immediate Action Taken Details
            <div className="homeInfoContainer">
                <Input.TextArea
                    placeholder="Enter Details (max length 500 characters)"
                    style={{
                        resize: "none",
                        height: "100px",
                        marginTop: "8px",
                        paddingBottom: "5px",
                        paddingTop: "5px"
                    }}
                    onChange={(e) => {
                        setHazardCard({...hazardCard, immediateActionTakenDetails: e.target.value, updateHazardRequired: true});
                        setMaxChar(e.target.value.length);
                    }}
                    disabled={hazardCard.status === 'closed' || hazardCard.status === 'void' ? true : !isRep}
                    value={hazardCard.immediateActionTakenDetails}
                    className={(hazardCard.validatedImmediateActionTakenDetails && hazardCard.validatedImmediateActionTakenDetails !== "") ? "inputText homeValidationInputText" : "inputText"}
                />
                {(hazardCard.validatedImmediateActionTakenDetails && hazardCard.validatedImmediateActionTakenDetails !== "") &&
                    <span className="homeValidationMessage">{hazardCard.validatedImmediateActionTakenDetails}</span>
                }
                {isRep && <span className="maxCharMessage">{maxChar}/500</span>}
            </div>
        </>
    )
}

export default ActionTakenInput
